{"id":"Logo","prefabs":{"default":{"children":[{"component":"Logo","options":"options:*"}]}}}